<template>
  <q-page padding>
    <PageHeader
      title="Movimentações da Ferramenta"
      :backRoute="{ name: 'ferramentaria-movimentar-status-ferramenta' }"
      backBehavior="route"
    />

    <div class="row col-12 q-mt-md q-gutter-sm text-brand-5 text-weight-bold">
      <div class="col-md-2 col-xs">
        <div class="texto-titulo-input">Código</div>
        <q-input
          v-model="codigoItem"
          class="input"
          disable
          bg-color="brand-7"
          dense
          outlined
        />
      </div>
      <div class="col-md-2 col-xs">
        <div class="texto-titulo-input">Status</div>
        <q-input
          v-model="dadoAtivo.status"
          disable
          bg-color="brand-7"
          dense
          outlined
          class="input"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 justify-between items-center q-mb-sm">
        <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
          <span>Lista de Movimentações</span>
        </div>
      </div>
      <q-linear-progress v-if="loading" indeterminate size="3px" />
      <q-table
        :columns="columns"
        dense
        :rows="listaMovimentacao"
        :hide-bottom="!listaMovimentacao.length == 0"
        :class="{ 'my-sticky-dynamic': !mobile }"
        :rows-per-page-options="[0]"
        flat
        no-data-label="Nenhuma movimentação encontrada."
        :grid="mobile"
      >
        <template v-slot:item="props">
          <q-card class="container-grid-table col-12 q-mt-sm">
            <div class="q-pa-sm">
              <div class="row col-12 items-center">
                <div class="col-8">
                  <div class="row col-12 items-center">
                    <strong class="q-mr-xs">Tipo:</strong>
                    <span>
                      {{ props.row.tipo }}
                    </span>
                  </div>
                  <div class="row col-12 items-center">
                    <strong class="q-mr-xs">Chave:</strong>
                    <span> {{ props.row.chave }}</span>
                  </div>
                  <div class="row col-12 items-center">
                    <strong class="q-mr-xs">Etapa:</strong>
                    <span>
                      {{
                        props.row?.etapa == "movimentacao_manual"
                          ? "Movimentação Manual"
                          : props.row?.etapa == "transferencia_interna_envio"
                          ? "Transferência Interna Envio"
                          : props.row?.etapa == "transferencia_externa_envio"
                          ? "Transferência Externa Envio"
                          : props.row?.etapa == "emprestimo"
                          ? "Empréstimo"
                          : props.row?.etapa == "movimentacao_manual_nf"
                          ? "Movimentação Manual NF"
                          : props.row?.etapa == "devolucao"
                          ? "Devolução"
                          : props.row?.etapa == "movimentacao_manual_voucher"
                          ? "Movimentação Manual Voucher"
                          : props.row?.etapa == "movimentacao_manual_romaneio"
                          ? "Movimentação Manual Romaneio"
                          : props.row?.etapa == "movimentacao_manual_estoque"
                          ? "Movimentação Manual Estoque"
                          : props.row?.etapa == "transferencia_interna"
                          ? "Transferência Interna"
                          : props.row?.etapa ==
                            "transferencia_interna_recebimento"
                          ? "Transferência Interna Recebimento"
                          : props.row?.etapa == "transferencia_externa"
                          ? "Transferência Externa"
                          : props.row?.etapa ==
                            "transferencia_externa_recebimento"
                          ? "Transferência Externa Recebimento"
                          : props.row?.etapa == "edicao_manual"
                          ? "Edição Manual"
                          : ""
                      }}</span
                    >
                  </div>
                  <div class="row col-12 items-center">
                    <strong class="q-mr-xs">Valor Inicial:</strong>
                    <span v-if="props.row?.valorInicial?.includes('https')">
                      <a
                        style="text-decoration: none; color: #707070"
                        :href="props.row?.valorInicial"
                      >
                        {{ props.row?.valorInicial }}</a
                      >
                    </span>
                    <span v-else>
                      {{ props.row?.valorInicial }}
                    </span>
                  </div>
                  <div class="row col-12 items-center">
                    <strong class="q-mr-xs">Valor Final:</strong>
                    <span v-if="props.row?.valorFinal?.includes('https')">
                      <a
                        style="text-decoration: none; color: #707070"
                        :href="props.row?.valorFinal"
                      >
                        {{ props.row?.valorFinal }}</a
                      >
                    </span>
                    <span v-else>
                      {{ props.row?.valorFinal }}
                    </span>
                  </div>
                  <div class="row col-12 items-center">
                    <strong class="q-mr-xs">Usuário:</strong>
                    <span> {{ props.row.usuarioNome }}</span>
                  </div>
                  <div class="row col-12 items-center">
                    <strong class="q-mr-xs">Data de Alteração:</strong>
                    <span>
                      {{
                        props.row?.alteradoEm
                          ?.split(" ")[0]
                          ?.split("-")
                          ?.reverse()
                          ?.join("/")
                      }}</span
                    >
                  </div>
                  <div class="row col-12 items-center">
                    <strong class="q-mr-xs">Qtd Anexos:</strong>
                    <span> {{ props.row?.anexos?.length }}</span>
                  </div>
                </div>
                <div class="col">
                  <div class="row col-12 justify-end">
                    <q-btn
                      icon="article"
                      color="secondary"
                      flat
                      round
                      @click="
                        (rightDrawerOpen = true),
                          (listaAnexoMovimentacao = props.row.anexos)
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </q-card>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td>
              {{ props.row.tipo }}
            </q-td>
            <q-td>
              {{ props.row.chave }}
            </q-td>
            <q-td>
              {{
                props.row?.etapa == "movimentacao_manual"
                  ? "Movimentação Manual"
                  : props.row?.etapa == "transferencia_interna_envio"
                  ? "Transferência Interna Envio"
                  : props.row?.etapa == "transferencia_externa_envio"
                  ? "Transferência Externa Envio"
                  : props.row?.etapa == "emprestimo"
                  ? "Empréstimo"
                  : props.row?.etapa == "movimentacao_manual_nf"
                  ? "Movimentação Manual NF"
                  : props.row?.etapa == "devolucao"
                  ? "Devolução"
                  : props.row?.etapa == "movimentacao_manual_voucher"
                  ? "Movimentação Manual Voucher"
                  : props.row?.etapa == "movimentacao_manual_romaneio"
                  ? "Movimentação Manual Romaneio"
                  : props.row?.etapa == "movimentacao_manual_estoque"
                  ? "Movimentação Manual Estoque"
                  : props.row?.etapa == "transferencia_interna"
                  ? "Transferência Interna"
                  : props.row?.etapa == "transferencia_interna_recebimento"
                  ? "Transferência Interna Recebimento"
                  : props.row?.etapa == "transferencia_externa"
                  ? "Transferência Externa"
                  : props.row?.etapa == "transferencia_externa_recebimento"
                  ? "Transferência Externa Recebimento"
                  : props.row?.etapa == "transferencia_manual_estoque"
                  ? "Transferência Manual Estoque"
                  : props.row?.etapa == "transferencia_manual_voucher"
                  ? "Transferência Manual Voucher"
                  : props.row?.etapa == "edicao_manual"
                  ? "Edição Manual"
                  : ""
              }}
            </q-td>
            <q-td>
              <span v-if="props.row?.valorInicial?.includes('https')">
                <a
                  style="text-decoration: none; color: #707070"
                  :href="props.row?.valorInicial"
                >
                  {{ props.row?.valorInicial }}</a
                >
              </span>
              <span v-else>
                {{ props.row?.valorInicial }}
              </span>
            </q-td>
            <q-td>
              <span v-if="props.row?.valorFinal?.includes('https')">
                <a
                  style="text-decoration: none; color: #707070"
                  :href="props.row?.valorFinal"
                >
                  {{ props.row?.valorFinal }}</a
                >
              </span>
              <span v-else>
                {{ props.row?.valorFinal }}
              </span>
            </q-td>
            <q-td>
              {{ props.row?.usuarioNome }}
            </q-td>
            <q-td>
              {{
                props.row?.alteradoEm
                  ?.split(" ")[0]
                  ?.split("-")
                  ?.reverse()
                  ?.join("/")
              }}
            </q-td>
            <q-td>
              {{ props.row?.anexos?.length }}
            </q-td>
            <q-td>
              <q-btn
                icon="article"
                color="secondary"
                flat
                round
                @click="
                  (rightDrawerOpen = true),
                    (listaAnexoMovimentacao = props.row.anexos)
                "
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div class="row justify-center q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          :size="mobile ? 'md' : 'sm'"
        />
      </div>
    </div>
    <Transition name="slide-fade">
      <q-card v-if="rightDrawerOpen" class="drawer-modal">
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center">
            <q-icon
              style="cursor: pointer"
              name="close"
              class="q-mr-md"
              size="22px"
              @click="rightDrawerOpen = false"
            />
            <span class="texto-titulo-modal"> Anexos </span>
          </div>
        </div>
        <q-scroll-area style="width: 100%; height: 89%">
          <div class="column col-12 justify-between no-wrap container-modal">
            <div class="q-px-md">
              <div class="col-12 q-mt-lg">
                <q-table
                  grid
                  hide-bottom
                  dense
                  :rows="listaAnexoMovimentacao"
                  :rows-per-page-options="[0]"
                >
                  <template v-slot:item="props">
                    <div class="col-12 q-mt-sm">
                      <div class="row card text-grid-table q-pa-sm">
                        <div class="row col-12 justify-between items-center">
                          <div class="col">
                            <div class="row col-12 q-mt-sm">
                              <span class="row col-12 q-mr-sm"
                                ><strong class="q-mr-xs">Nome: </strong>
                                {{ props.row.nome }}</span
                              >
                              <span class="row col-12 q-mr-sm"
                                ><strong class="q-mr-xs">Data: </strong>
                                {{
                                  props.row.criadoEm
                                    .split(" ")[0]
                                    .split("-")
                                    .reverse()
                                    .join("/")
                                }}</span
                              >
                            </div>
                          </div>
                          <div class="col-4">
                            <div class="row col-12 justify-end items-center">
                              <div>
                                <q-btn
                                  color="secondary"
                                  icon="download"
                                  round
                                  flat
                                  :href="props.row.urlAnexo"
                                />
                              </div>
                              <!-- <div>
                                  <q-btn color="red" icon="delete" round flat />
                                </div> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </q-table>
              </div>
            </div>
          </div>
        </q-scroll-area>
      </q-card>
    </Transition>
    <q-dialog v-model="confirm" persistent>
      <q-card
        class="row items-between q-pa-sm container-modal-excluir text-brand-5 text-weight-bolder q-pa-xl"
      >
        <q-card-section class="row col-12 justify-center">
          <span class="texto-excluir-pai"
            >TEM CERTEZA QUE DESEJA ENVIAR O ARQUIVO "{{ file?.name }}"?</span
          >
        </q-card-section>

        <div class="row col-12 justify-center items-end q-mb-md">
          <q-btn
            no-caps
            label="Enviar"
            color="positive"
            v-close-popup
            class="btn-excluir"
            icon="check_circle_outline"
          />
          <q-btn
            icon="cancel"
            no-caps
            label="Cancelar"
            color="negative"
            class="btn-excluir q-ml-md"
            v-close-popup
            @click="file = null"
          />
        </div>
      </q-card>
    </q-dialog>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
  </q-page>
</template>

<script>
import { onMounted, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
import PageHeader from "../../../components/PageHeader.vue";

const columns = [
  {
    name: "tipo",
    label: "Tipo",
    align: "left",
  },
  {
    name: "chave",
    label: "Chave",
    align: "left",
  },
  {
    name: "etapa",
    label: "Etapa",
    align: "left",
  },
  {
    name: "valorInicial",
    label: "Valor Inicial",
    align: "left",
  },
  {
    name: "valorFinal",
    label: "Valor Final",
    align: "left",
  },
  {
    name: "usuario",
    label: "Usuário",
    align: "left",
  },
  {
    name: "alteradoEm",
    label: "Alterado Em",
    align: "left",
  },
  {
    name: "numeroAnexos",
    label: "Qtd de Anexos",
    align: "left",
  },
  {
    name: "Anexos",
    label: "Anexos",
    align: "left",
  },
];
export default {
  components: {
    PageHeader,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const quasar = useQuasar();

    const dadoMovimentacao = ref({});
    const statusFerramenta = ref("");
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    let disable = ref(false);
    let rightDrawerOpen = ref(false);
    const file = ref(null);
    let confirm = ref(false);
    const listaAnexoMovimentacao = ref([]);
    const dadoAtivo = ref({});
    const listaMovimentacao = ref([]);
    const codigoItem = ref("");
    let loading = ref(false);
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const receberDadoAtivo = async () => {
      await store.state.org.unidadeData.id;
      try {
        const response = await store.dispatch("ferramentaria/listarAtivo", {
          unidadeId: store.state.org.unidadeData.id,
          page: 1,
          per_page: 1,
          ativoUuid: route.params.ferramentaId,
        });

        dadoAtivo.value = { ...response.response.data.resultado.dados[0] };
        codigoItem.value = dadoAtivo.value?.catalogoItem?.codigo;
        dadoAtivo.value.status = `${dadoAtivo.value.status
          .charAt(0)
          .toUpperCase()}${dadoAtivo.value.status.substring(1)}`;
      } catch (error) {
        console.log(error);
      }
    };

    const listarMovimentacao = async (page = 1, perPage = 10) => {
      disable.value = true;
      loading.value = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/listarMovimentacaoAtivo",
          {
            ativoUuid: route.params.ferramentaId,
            page,
            perPage,
          }
        );
        listaMovimentacao.value = response.data.resultado.dados;
        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.rowsPerPage = response.data.resultado.perPage;
        pagination.value.rowsNumber = response.data.resultado.total;
        disable.value = false;
        loading.value = false;
      } catch (error) {
        disable.value = false;
        loading.value = false;
        console.log(error);
      }
    };

    const receberAnexoMovimentacao = async () => {
      try {
        const response = await store.dispatch(
          "ferramentaria/receberAnexoMovimentacao"
        );
        listaAnexoMovimentacao.value = response.resultado.data;
      } catch (error) {
        console.log(error);
      }
    };

    const abrirDialogoArquivo = () => {
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.style.display = "none";
      fileInput.addEventListener("change", handleFileChange);
      document.body.appendChild(fileInput);
      fileInput.click();
    };

    const handleFileChange = (event) => {
      file.value = event.target.files[0];
      event.target.removeEventListener("change", handleFileChange);
      event.target.remove();
      confirm.value = true;
    };

    watch(
      () => pagination.value.page,
      () => {
        listarMovimentacao(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    onMounted(() => {
      receberDadoAtivo();
      listarMovimentacao();
    });

    return {
      columns,
      dadoMovimentacao,
      statusFerramenta,
      pagination,
      disable,
      confirm,
      rightDrawerOpen,
      file,
      receberAnexoMovimentacao,
      listaAnexoMovimentacao,
      dadoAtivo,
      listaMovimentacao,
      codigoItem,
      loading,
      listarMovimentacao,
      mobile,
      handleFileChange,
      abrirDialogoArquivo,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}
tbody tr td {
  white-space: pre-wrap;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100% !important;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.container-ferramenta-selecionada {
  border: 1px solid black;
  padding: 10px;
  border-radius: 10px;
}
.texto-titulo {
  font-size: 20px;
}
.icon-voltar {
  font-size: 25px;
}
.container-link-voltar {
  margin-right: 10px;
}
input[type="file"] {
  display: none;
}
.btn-upload {
  margin: 9px 0px 0px 0px;
}
a {
  text-decoration: none;
  color: white;
}
.texto-excluir-pai {
  text-align: center;
  text-justify: inter-word;
  font-size: 19px;
  font-weight: bold;
  color: black;
}
.texto-excluir-filho {
  text-align: center;
  text-justify: inter-word;
  font-size: 15px;
}
.btn-excluir {
  font-size: 16px;
  padding: 0px 25px;
}
.card {
  border: 1px solid #707070;
  border-radius: 5px;
}
.text-grid-table {
  font-size: 14px;
}
.titulo-tabela {
  font-size: 18px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
.texto-titulo-modal {
  font-size: 16px;
}
.texto-upload {
  font-size: 14px;
  font-weight: bold;
}
.container-modal-excluir {
  width: 590px;
}
@media (max-width: 1400px) {
  .drawer-modal {
    height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1000px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 100%;
    height: 85%;
    overflow: hidden;
    top: 103px;
    width: 340px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
  .input {
    font-size: 12px;
  }

  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .btn-upload {
    font-size: 11px;
  }
  .texto-upload {
    font-size: 9px;
    font-weight: bold;
  }
  .texto-titulo-modal {
    font-size: 14px !important;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .container-modal-excluir {
    width: 100%;
    height: 250px;
    padding: 10px 10px 0px 10px;
    margin: 0px;
    border-radius: 10px;
  }
  .texto-excluir-pai {
    font-size: 17px;
  }
  .texto-excluir-filho {
    font-size: 14px;
  }
  .btn-excluir {
    font-size: 12px;
  }
}
</style>
